module.exports = __webpack_public_path__ + "img/01.12930fb5.png";